import React, { useCallback } from "react";
import client from "@culturehq/client";
import { Button } from "@culturehq/components";

import { Trans } from "app/utils";
import OrganizationValueLink from "app/links/OrganizationValueLink";

import { TimeDiff } from "components/common/Time";

import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";
import OrganizationValueModal from "./OrganizationValueModal";

const OrganizationValueRow = ({ organizationValue, onUpdate, onDelete }) => {
  const onConfirmDelete = useCallback(
    async () => {
      await client.deleteOrganizationValue({
        organizationValueId: organizationValue.id
      });

      onDelete(organizationValue);
    },
    [organizationValue, onDelete]
  );

  return (
    <tr>
      <td>
        <OrganizationValueLink orgValue={organizationValue} />
      </td>
      <td>
        <TimeDiff time={organizationValue.createdAt} />
      </td>
      <td>
        <TimeDiff time={organizationValue.updatedAt} />
      </td>
      <td className="Actions-column">
        <OrganizationValueModal organizationValue={organizationValue} onUpdate={onUpdate}>
          {onTrigger => (
            <Button icon="edit-outlined" onClick={onTrigger} inverted />
          )}
        </OrganizationValueModal>
        <ChqModalConfirmDelete
          onAccept={onConfirmDelete}
          trigger={onTrigger => (
            <Button icon="trash-a-outlined" onClick={onTrigger} inverted />
          )}
        >
          <Trans>Are you sure you would like to delete this value?</Trans>
        </ChqModalConfirmDelete>
      </td>
    </tr>
  );
};

export default OrganizationValueRow;
